import { createSlice } from "@reduxjs/toolkit";

const init = {
  city: "Calgary",
  feedbackDetailsDialogStatus: { open: false, row: {} },
  feedbackRequestDialogStatus: {
    open: false,
    clientProjectId: null,
    feedback: null,
    contact: null,
    relatedProject: null,
    office: "",
    surveyType: null,
  },
};

const experienceSlice = createSlice({
  name: "experience",
  initialState: init,
  reducers: {
    setCity(state, action) {
      state.city = action.payload;
    },

    openFeedbackDetailsDialogStatus(state, action) {
      state.feedbackDetailsDialogStatus = { open: true, row: action.payload };
    },

    closeFeedbackDetailsDialogStatus(state) {
      state.feedbackDetailsDialogStatus = init.feedbackDetailsDialogStatus;
    },

    openFeedbackRequestDialogStatus(state, action) {
      state.feedbackRequestDialogStatus = { ...action.payload, open: true, sent: false };
    },

    closeFeedbackRequestDialog(state) {
      state.feedbackRequestDialogStatus = init.feedbackRequestDialogStatus;
    },
  },
});

export const experienceActions = experienceSlice.actions;

export default experienceSlice.reducer;
